import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/icons/icons'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'NumerationTitleComponent',
  setup(__props) {

const { t } = useI18n()

const texts = {
  faq: {
    q1: t('components.numeration.faq.q1'),
    q2: t('components.numeration.faq.q2'),
    q3: t('components.numeration.faq.q3')
  }
}


return { __sfc: true,t, texts, Icons }
}

})